import { useState } from 'react';
import useModal from './useModal';

export const useTermFullsheet = () => {
  const [title, setTitle] = useState<string>('');
  const [path, setPath] = useState<string>('');
  const [termsCd, setTermCd] = useState<string>('');

  const { isOpen, open: modalOpen, close: modalClose } = useModal();

  const open = (title: string, path: string, termsCd?: string) => {
    setTitle(title);
    setPath(path);
    setTermCd(termsCd ?? '');
    modalOpen();
  };

  const close = () => {
    modalClose();
    setTitle('');
    setPath('');
    setTermCd('');
  };

  return {
    isOpen,
    open,
    close,
    title,
    path,
    termsCd,
  };
};
